
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'locationsPage': {'display': `flex`,'flexGrow': `1`,'justifyContent': `space-around`,'flexWrap': `wrap`,'paddingTop': `48px`,'paddingBottom': `7rem`,},
        
      };
    };
  